export interface AcceptInvitationDto {
    firstName: string;
    lastName: string;
    locale: string;
    acceptPolicy: boolean;
    subscribeMarketing?: boolean;
    organizationName?: string;
}
